export default __webpack_public_path__ + "static/media/appModeRemoteH1.1953414e.png";